import { useContext } from 'react';

import {
  type EmitSidekickFeatureEvent,
  type SidekickFeatureEventReporter,
  SidekickFeatureEventsContext,
} from './SidekickFeatureEventsContext';

const IGNORE_FEATURE_EVENT: EmitSidekickFeatureEvent = () => undefined;

// Outside a provider nothing is reported, but submissions still run.
const IGNORING_REPORTER: SidekickFeatureEventReporter = {
  emit: IGNORE_FEATURE_EVENT,
  captureEmit: () => IGNORE_FEATURE_EVENT,
  emitOnQuestionSent: (_event, { submit }) => {
    submit();
  },
};

/**
 * Reads the nearest `SidekickFeatureEventsProvider`'s full reporter.
 * @returns The reporter; outside a provider it reports nothing.
 */
export const useSidekickFeatureEventReporter =
  (): SidekickFeatureEventReporter =>
    useContext(SidekickFeatureEventsContext) ?? IGNORING_REPORTER;

/**
 * Reports feature events to the host through the nearest
 * `SidekickFeatureEventsProvider`.
 * @returns The emitter; outside a provider it reports nothing.
 */
export const useSidekickFeatureEvent = (): EmitSidekickFeatureEvent =>
  useSidekickFeatureEventReporter().emit;
